import { useMutation, useQuery } from 'react-query';
import companyAvailabilityServices from './company-availability.services';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { CompanyAvailabilityListRequest } from './company-availability.types';
import { queryClient } from '@/Root';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const QUERY_COMPANY_AVAILABILITY_LIST = 'company/availability/list';

export function useCompanyAvailabilityList(
  params: CompanyAvailabilityListRequest,
) {
  return useQuery({
    queryKey: [QUERY_COMPANY_AVAILABILITY_LIST, params],
    queryFn: () => companyAvailabilityServices.list(params),
    enabled:
      !!params.companyId &&
      hasPermissions([Authorities.COMPANY_AVAILABILITY_VIEW]),
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCompanyAvailabilityCreate() {
  return useMutation({
    mutationFn: companyAvailabilityServices.create,
    async onSuccess() {
      notification.success({
        message: 'Disponibilidade da semana cadastrada com sucesso.',
      });

      await queryClient.invalidateQueries({
        queryKey: [QUERY_COMPANY_AVAILABILITY_LIST],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCompanyAvailabilityDelete() {
  return useMutation({
    mutationFn: companyAvailabilityServices.delete,
    async onSuccess() {
      notification.success({
        message: 'Disponibilidade da semana removido com sucesso.',
      });

      await queryClient.invalidateQueries({
        queryKey: [QUERY_COMPANY_AVAILABILITY_LIST],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCompanyAvailabilityEdit() {
  return useMutation({
    mutationFn: companyAvailabilityServices.edit,
    async onSuccess() {
      notification.success({
        message: 'Disponibilidade da semana atualizado com sucesso.',
      });

      await queryClient.invalidateQueries({
        queryKey: [QUERY_COMPANY_AVAILABILITY_LIST],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
